import { gql } from '@apollo/client';
import { ImageFragment } from '../../fragments/image';

export const QUERY_CURRENT_DAILY_INSIGHT = gql`
  query dailyInsight($date: DateFilterInput) {
    insights(filters: { day: $date }) {
      data {
        id
        attributes {
          title
          type
          subHeader
          cover {
            data {
              ...ImageFragment
            }
          }
          themes {
            data {
              attributes {
                theme
                topic {
                  data {
                    attributes {
                      topic
                    }
                  }
                }
              }
            }
          }
          duration
          day
          resource {
            data {
              attributes {
                slug
              }
            }
          }
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonTheme {
              theme
            }
            ... on ComponentCommonMedia {
              media {
                data {
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
            }
            ... on ComponentCommonTitle {
              title
            }

            ... on ComponentCommonButton {
              text
              link
            }

            ... on ComponentCommonAuthor {
              author {
                data {
                  attributes {
                    name
                    role
                  }
                }
              }
              publicationDate
            }

            ... on ComponentCommonAuthorDetailed {
              authors {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }

            ... on ComponentCommonDivider {
              id
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            # ... on ComponentCommonAccordion {
            #   title
            #   accordionDescription: description
            # }

            ... on ComponentCommonTranscript {
              id
            }

            ... on ComponentCommonTextEditor {
              markdownText
            }

            ... on ComponentCommonDownloadableContentList {
              list {
                title
                description
                content {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_DAILY_INSIGHT_PAGE = gql`
  query insightPage {
    insightPage {
      data {
        attributes {
          relatedContentViewAllLabel
          relatedContentTitle
        }
      }
    }
  }
`;
